"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFileManagerPortalData = fetchFileManagerPortalData;
exports.updatePortalMeta = updatePortalMeta;
exports.updateVidyardTosStatus = updateVidyardTosStatus;
exports.updateVideoPQLDismissFlag = updateVideoPQLDismissFlag;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _immutable = require("immutable");

var _PortalMetaCategoryIds = _interopRequireDefault(require("../enums/PortalMetaCategoryIds"));

var BASE_URL = 'filemanager/api/v3/portal-meta';

function fetchFileManagerPortalData() {
  return _apiClient.default.get(BASE_URL).then(_immutable.fromJS);
}

var getCategoryName = function getCategoryName(categoryId) {
  return Object.keys(_PortalMetaCategoryIds.default).find(function (name) {
    return _PortalMetaCategoryIds.default[name] === categoryId;
  });
};

function updatePortalMeta(_ref) {
  var category = _ref.category,
      category_value = _ref.category_value;
  var categoryName = getCategoryName(category);
  var data = {
    category: category,
    category_value: category_value
  };
  var query = {
    categoryName: categoryName
  };
  return _apiClient.default.post(BASE_URL + "/upsert", {
    data: data,
    query: query
  }).then(_immutable.fromJS);
}

function updateVidyardTosStatus(status) {
  return updatePortalMeta({
    category: _PortalMetaCategoryIds.default.VIDYARD_TOS_STATUS,
    category_value: status
  });
}

function updateVideoPQLDismissFlag(hasDismissedVideoPQL) {
  return updatePortalMeta({
    category: _PortalMetaCategoryIds.default.DISMISS_VIDEO_PQL_V1,
    category_value: hasDismissedVideoPQL
  });
}